var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContractList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82386 16.0812H4.24588C3.61812 16.0812 3.01607 15.8318 2.57218 15.388C2.12828 14.9441 1.87891 14.342 1.87891 13.7143V12.9253H6.21835M12.9248 6.21884V3.45738C12.9248 3.14528 13.0173 2.84019 13.1907 2.5807C13.3641 2.3212 13.6105 2.11895 13.8989 1.99951C14.1872 1.88008 14.5045 1.84883 14.8106 1.90972C15.1167 1.9706 15.3979 2.12089 15.6186 2.34158C15.8392 2.56226 15.9895 2.84343 16.0504 3.14953C16.1113 3.45563 16.0801 3.77291 15.9606 4.06124C15.8412 4.34958 15.6389 4.59603 15.3794 4.76942C15.1199 4.94281 14.8149 5.03536 14.5028 5.03536H12.9248M14.5028 1.87939H5.8239C5.19614 1.87939 4.59409 2.12877 4.15019 2.57266C3.7063 3.01656 3.45692 3.61861 3.45692 4.24637V12.9253M6.61289 5.03536H9.76885M6.61289 8.19132H9.76885M14.0452 9.46159C14.3559 9.15085 14.7774 8.97628 15.2168 8.97628C15.6563 8.97628 16.0777 9.15085 16.3885 9.46159C16.6992 9.77233 16.8738 10.1938 16.8738 10.6332C16.8738 11.0727 16.6992 11.4942 16.3885 11.8049L11.3468 16.8702H8.97986V14.5032L14.0452 9.46159Z",
    stroke: "#435869",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractList);
export default __webpack_public_path__ + "static/media/icContractList.2b11a554ab65aef3fd93bf9ce79da156.svg";
export { ForwardRef as ReactComponent };